import { BlogType } from 'app/entities/types'

export const getBlogSlugFromLocation = (path: string): string => {
  if (path.includes(BlogType.Blog) === true) return BlogType.Blog
  if (path.includes(BlogType.PressReleases) === true) return BlogType.PressReleases
  if (path.includes(BlogType.IoSonoVege) === true) return BlogType.IoSonoVege
  return BlogType.Blog
}
